import {Card, Typography, Badge} from "antd";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {FolderOpenFilled} from '@ant-design/icons';

const { Title } = Typography;

function CategoryItem({id, name, count}){
    let navigate = useNavigate()
    const { t } = useTranslation();
    
    const handleOpenTest = (id)=>{
        navigate(`/categories/${id}`)
    }

    return (
        <Card 
            hoverable 
            onClick={() => handleOpenTest(id)}
            style={{ 
                borderRadius: '12px',
                overflow: 'hidden',
                height: '100%',
                transition: 'all 0.3s',
                border: '1px solid #f0f0f0'
            }}
            bodyStyle={{ padding: '24px 15px', textAlign: 'center' }}
        >
            <div style={{ fontSize: '32px', marginBottom: '15px', color: '#1890ff' }}>
                <FolderOpenFilled />
            </div>
            <Title level={5} style={{ marginBottom: 15, height: '50px', overflow: 'hidden' }}>
                {name}
            </Title>
            <Badge 
                count={t('categories.questions_count', { count })} 
                style={{ backgroundColor: '#e6f7ff', color: '#1890ff', border: '1px solid #91d5ff' }} 
            />
        </Card>
    )
}
export default CategoryItem;
